import { Footer } from "./Footer";
import { Navbar } from "./Navbar";

export function BaseLayout({children}: {children: React.ReactNode}) {
    return (
        <main className="relative z-10 min-h-screen bg-background mt-0">
            <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 via-blue-500/5 to-indigo-500/10 rounded-2xl blur-3xl -z-10"></div>
            <Navbar />
            <div className="overflow-x-hidden p-6 md:p-8 space-y-28 ">
                {children}
                <Footer />
            </div>
        </main>
    );
}

